import { render, staticRenderFns } from "./assignment-document-preview.vue?vue&type=template&id=1beb1eed"
import script from "./assignment-document-preview.vue?vue&type=script&lang=js"
export * from "./assignment-document-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports